"use client";

import { c as _c } from "react/compiler-runtime";
import { DELEGATION_ABI } from "@/abis/abis";
import { useAuth } from "@/components/auth/Auth";
import { PRIMARY_ADDRESS_USE_CASE } from "@/components/delegation/delegation-constants";
import EtherscanIcon from "@/components/user/utils/icons/EtherscanIcon";
import OpenseaIcon from "@/components/user/utils/icons/OpenseaIcon";
import CopyIcon from "@/components/utils/icons/CopyIcon";
import { DELEGATION_ALL_ADDRESS, DELEGATION_CONTRACT, NEVER_DATE } from "@/constants/constants";
import type { ApiWallet } from "@/generated/models/ApiWallet";
import { getTransactionLink } from "@/helpers/Helpers";
import { TOOLTIP_STYLES } from "@/helpers/tooltip.helpers";
import { ChevronDownIcon } from "@heroicons/react/24/outline";
import { useEffect, useRef, useState } from "react";
import { Tooltip } from "react-tooltip";
import { useCopyToClipboard } from "react-use";
import { useWaitForTransactionReceipt, useWriteContract } from "wagmi";
import UserPageIdentityStatementsConsolidatedAddressesItemPrimary from "./UserPageIdentityStatementsConsolidatedAddressesItemPrimary";
export default function UserPageIdentityStatementsConsolidatedAddressesItem(t0) {
  const $ = _c(105);
  const {
    address,
    primaryAddress,
    canEdit,
    isOpen,
    onToggleOpen
  } = t0;
  const {
    setToast
  } = useAuth();
  let t1;
  if ($[0] !== address.wallet) {
    t1 = e => {
      e.stopPropagation();
      window.open(`https://opensea.io/${address.wallet}`, "_blank");
    };
    $[0] = address.wallet;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const goToOpensea = t1;
  let t2;
  if ($[2] !== address.wallet) {
    t2 = e_0 => {
      e_0.stopPropagation();
      window.open(`https://etherscan.io/address/${address.wallet}`, "_blank");
    };
    $[2] = address.wallet;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const goToEtherscan = t2;
  let t3;
  if ($[4] !== address.wallet) {
    t3 = address.wallet.toLowerCase();
    $[4] = address.wallet;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== primaryAddress) {
    t4 = primaryAddress?.toLowerCase();
    $[6] = primaryAddress;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const isPrimary = t3 === t4;
  const [copiedItem, setCopiedItem] = useState(null);
  const resetTimerRef = useRef(null);
  const [, copyToClipboard] = useCopyToClipboard();
  let t5;
  if ($[8] !== address.wallet || $[9] !== copyToClipboard) {
    t5 = event => {
      event.stopPropagation();
      copyToClipboard(address.wallet);
      setCopiedItem("full-address");
      if (resetTimerRef.current) {
        clearTimeout(resetTimerRef.current);
      }
      resetTimerRef.current = setTimeout(() => {
        setCopiedItem(_temp);
        resetTimerRef.current = null;
      }, 1000);
    };
    $[8] = address.wallet;
    $[9] = copyToClipboard;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  const handleCopyAddress = t5;
  let t6;
  if ($[11] !== address.display || $[12] !== copyToClipboard) {
    t6 = event_0 => {
      if (!address.display) {
        return;
      }
      event_0.stopPropagation();
      copyToClipboard(address.display);
      setCopiedItem("ens");
      if (resetTimerRef.current) {
        clearTimeout(resetTimerRef.current);
      }
      resetTimerRef.current = setTimeout(() => {
        setCopiedItem(_temp2);
        resetTimerRef.current = null;
      }, 1000);
    };
    $[11] = address.display;
    $[12] = copyToClipboard;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  const handleCopyEns = t6;
  let t7;
  let t8;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = () => () => {
      if (resetTimerRef.current) {
        clearTimeout(resetTimerRef.current);
      }
    };
    t8 = [];
    $[14] = t7;
    $[15] = t8;
  } else {
    t7 = $[14];
    t8 = $[15];
  }
  useEffect(t7, t8);
  const [isTouchScreen, setIsTouchScreen] = useState(false);
  let t10;
  let t9;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = () => {
      setIsTouchScreen(window.matchMedia("(pointer: coarse)").matches);
    };
    t10 = [];
    $[16] = t10;
    $[17] = t9;
  } else {
    t10 = $[16];
    t9 = $[17];
  }
  useEffect(t9, t10);
  const [assigningPrimary, setAssigningPrimary] = useState(false);
  const [statusMessage, setStatusMessage] = useState();
  const writeDelegation = useWriteContract();
  let t11;
  if ($[18] !== writeDelegation.data) {
    t11 = {
      confirmations: 1,
      hash: writeDelegation.data
    };
    $[18] = writeDelegation.data;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  const waitWriteDelegation = useWaitForTransactionReceipt(t11);
  let t12;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = function getError(e_1) {
      return e_1.message.split("Request Arguments")[0];
    };
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  const getError = t12;
  let t13;
  if ($[21] !== setToast || $[22] !== waitWriteDelegation.data || $[23] !== waitWriteDelegation.error || $[24] !== waitWriteDelegation.isLoading || $[25] !== writeDelegation.data || $[26] !== writeDelegation.isPending) {
    t13 = () => {
      if (writeDelegation.isPending) {
        setStatusMessage("Confirm in your wallet...");
      } else {
        if (writeDelegation.data) {
          const trxLink = <>{writeDelegation.data && <a href={getTransactionLink(DELEGATION_CONTRACT.chain_id, writeDelegation.data)} target="_blank" rel="noopener noreferrer" className="tw-text-primary-400 tw-underline">View Transaction</a>}</>;
          if (waitWriteDelegation.isLoading) {
            setStatusMessage(<>Waiting for confirmation... {trxLink}</>);
          } else {
            if (waitWriteDelegation.data) {
              setStatusMessage(<>Confirmed! Check back in a few minutes to see the change. {trxLink}</>);
              setToast({
                type: "success",
                message: "Primary address set successfully"
              });
            } else {
              if (waitWriteDelegation.error) {
                setStatusMessage(<>Error: {getError(waitWriteDelegation.error)} {trxLink}</>);
                setToast({
                  type: "error",
                  message: `Error setting primary address: ${getError(waitWriteDelegation.error)}`
                });
              }
            }
          }
        } else {
          setStatusMessage(undefined);
        }
      }
    };
    $[21] = setToast;
    $[22] = waitWriteDelegation.data;
    $[23] = waitWriteDelegation.error;
    $[24] = waitWriteDelegation.isLoading;
    $[25] = writeDelegation.data;
    $[26] = writeDelegation.isPending;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  let t14;
  if ($[28] !== waitWriteDelegation.status || $[29] !== writeDelegation.status) {
    t14 = [writeDelegation.status, waitWriteDelegation.status];
    $[28] = waitWriteDelegation.status;
    $[29] = writeDelegation.status;
    $[30] = t14;
  } else {
    t14 = $[30];
  }
  useEffect(t13, t14);
  let t15;
  if ($[31] !== address.wallet || $[32] !== writeDelegation) {
    t15 = async () => {
      setAssigningPrimary(true);
      writeDelegation.writeContract({
        address: DELEGATION_CONTRACT.contract,
        abi: DELEGATION_ABI,
        chainId: DELEGATION_CONTRACT.chain_id,
        functionName: "registerDelegationAddress",
        args: [DELEGATION_ALL_ADDRESS, address.wallet, NEVER_DATE, PRIMARY_ADDRESS_USE_CASE.use_case, true, 0]
      });
    };
    $[31] = address.wallet;
    $[32] = writeDelegation;
    $[33] = t15;
  } else {
    t15 = $[33];
  }
  const assignPrimary = t15;
  const t16 = `consolidated-address-panel-${address.wallet}`;
  let t17;
  if ($[34] !== address.wallet) {
    t17 = address.wallet.slice(0, 6);
    $[34] = address.wallet;
    $[35] = t17;
  } else {
    t17 = $[35];
  }
  let t18;
  if ($[36] !== isOpen || $[37] !== onToggleOpen || $[38] !== t16 || $[39] !== t17) {
    t18 = <button type="button" aria-expanded={isOpen} aria-controls={t16} onClick={onToggleOpen} className="tw-border-0 tw-bg-transparent tw-p-0 tw-text-left tw-font-mono tw-text-xs tw-font-normal tw-leading-none tw-text-iron-100 hover:tw-text-white focus:tw-outline-none focus:tw-ring-1 focus:tw-ring-inset focus:tw-ring-emerald-400">{t17}</button>;
    $[36] = isOpen;
    $[37] = onToggleOpen;
    $[38] = t16;
    $[39] = t17;
    $[40] = t18;
  } else {
    t18 = $[40];
  }
  let t19;
  if ($[41] !== assignPrimary || $[42] !== assigningPrimary || $[43] !== canEdit || $[44] !== isPrimary) {
    t19 = <UserPageIdentityStatementsConsolidatedAddressesItemPrimary isPrimary={isPrimary} canEdit={canEdit} assignPrimary={assignPrimary} isAssigningPrimary={assigningPrimary} />;
    $[41] = assignPrimary;
    $[42] = assigningPrimary;
    $[43] = canEdit;
    $[44] = isPrimary;
    $[45] = t19;
  } else {
    t19 = $[45];
  }
  let t20;
  if ($[46] !== t18 || $[47] !== t19) {
    t20 = <div className="tw-flex tw-items-center tw-gap-1">{t18}{t19}</div>;
    $[46] = t18;
    $[47] = t19;
    $[48] = t20;
  } else {
    t20 = $[48];
  }
  let t21;
  if ($[49] !== address.display || $[50] !== address.wallet || $[51] !== isOpen || $[52] !== onToggleOpen) {
    t21 = address.display && <button type="button" aria-expanded={isOpen} aria-controls={`consolidated-address-panel-${address.wallet}`} onClick={onToggleOpen} className="tw-mt-1 tw-max-w-full tw-truncate tw-border-0 tw-bg-transparent tw-p-0 tw-text-left tw-font-mono tw-text-xs tw-font-semibold tw-leading-4 tw-text-iron-100 hover:tw-text-white focus:tw-outline-none focus:tw-ring-1 focus:tw-ring-inset focus:tw-ring-emerald-400">{address.display}</button>;
    $[49] = address.display;
    $[50] = address.wallet;
    $[51] = isOpen;
    $[52] = onToggleOpen;
    $[53] = t21;
  } else {
    t21 = $[53];
  }
  let t22;
  if ($[54] !== t20 || $[55] !== t21) {
    t22 = <div className="tw-min-w-0 tw-flex-1">{t20}{t21}</div>;
    $[54] = t20;
    $[55] = t21;
    $[56] = t22;
  } else {
    t22 = $[56];
  }
  const t23 = `etherscan-tooltip-${address.wallet}`;
  const t24 = isTouchScreen ? null : "Etherscan";
  let t25;
  if ($[57] === Symbol.for("react.memo_cache_sentinel")) {
    t25 = <div className="tw-flex tw-h-3.5 tw-w-3.5 tw-flex-shrink-0 tw-items-center tw-justify-center"><EtherscanIcon /></div>;
    $[57] = t25;
  } else {
    t25 = $[57];
  }
  let t26;
  if ($[58] !== goToEtherscan || $[59] !== t23 || $[60] !== t24) {
    t26 = <button type="button" onClick={goToEtherscan} aria-label="Go to Etherscan" className="tw-cursor-pointer tw-border-none tw-bg-transparent tw-p-0.5 tw-text-iron-500 tw-transition tw-duration-300 tw-ease-out hover:tw-text-iron-200" data-tooltip-id={t23} data-tooltip-content={t24}>{t25}</button>;
    $[58] = goToEtherscan;
    $[59] = t23;
    $[60] = t24;
    $[61] = t26;
  } else {
    t26 = $[61];
  }
  let t27;
  if ($[62] !== address.wallet || $[63] !== isTouchScreen) {
    t27 = !isTouchScreen && <Tooltip id={`etherscan-tooltip-${address.wallet}`} place="top" positionStrategy="fixed" offset={8} opacity={1} style={TOOLTIP_STYLES} />;
    $[62] = address.wallet;
    $[63] = isTouchScreen;
    $[64] = t27;
  } else {
    t27 = $[64];
  }
  const t28 = `opensea-tooltip-${address.wallet}`;
  const t29 = isTouchScreen ? null : "Opensea";
  let t30;
  if ($[65] === Symbol.for("react.memo_cache_sentinel")) {
    t30 = <div className="tw-flex tw-h-3.5 tw-w-3.5 tw-flex-shrink-0 tw-items-center tw-justify-center"><OpenseaIcon /></div>;
    $[65] = t30;
  } else {
    t30 = $[65];
  }
  let t31;
  if ($[66] !== goToOpensea || $[67] !== t28 || $[68] !== t29) {
    t31 = <button type="button" onClick={goToOpensea} aria-label="Go to Opensea" className="tw-cursor-pointer tw-border-none tw-bg-transparent tw-p-0.5 tw-text-iron-500 tw-transition tw-duration-300 tw-ease-out hover:tw-text-iron-200" data-tooltip-id={t28} data-tooltip-content={t29}>{t30}</button>;
    $[66] = goToOpensea;
    $[67] = t28;
    $[68] = t29;
    $[69] = t31;
  } else {
    t31 = $[69];
  }
  let t32;
  if ($[70] !== address.wallet || $[71] !== isTouchScreen) {
    t32 = !isTouchScreen && <Tooltip id={`opensea-tooltip-${address.wallet}`} place="top" positionStrategy="fixed" offset={8} opacity={1} style={TOOLTIP_STYLES} />;
    $[70] = address.wallet;
    $[71] = isTouchScreen;
    $[72] = t32;
  } else {
    t32 = $[72];
  }
  const t33 = isOpen ? "Collapse consolidated address details" : "Expand consolidated address details";
  const t34 = `consolidated-address-panel-${address.wallet}`;
  const t35 = `tw-h-3.5 tw-w-3.5 tw-flex-shrink-0 tw-transition-transform tw-duration-300 tw-ease-out ${isOpen ? "tw-rotate-180" : ""}`;
  let t36;
  if ($[73] !== t35) {
    t36 = <ChevronDownIcon className={t35} aria-hidden="true" />;
    $[73] = t35;
    $[74] = t36;
  } else {
    t36 = $[74];
  }
  let t37;
  if ($[75] !== isOpen || $[76] !== onToggleOpen || $[77] !== t33 || $[78] !== t34 || $[79] !== t36) {
    t37 = <button type="button" aria-label={t33} aria-expanded={isOpen} aria-controls={t34} onClick={onToggleOpen} className="tw-border-0 tw-bg-transparent tw-p-0.5 tw-text-iron-500 tw-transition tw-duration-300 tw-ease-out hover:tw-text-iron-200 focus:tw-outline-none focus:tw-ring-1 focus:tw-ring-inset focus:tw-ring-emerald-400">{t36}</button>;
    $[75] = isOpen;
    $[76] = onToggleOpen;
    $[77] = t33;
    $[78] = t34;
    $[79] = t36;
    $[80] = t37;
  } else {
    t37 = $[80];
  }
  let t38;
  if ($[81] !== t26 || $[82] !== t27 || $[83] !== t31 || $[84] !== t32 || $[85] !== t37) {
    t38 = <div className="tw-ml-auto tw-flex tw-flex-shrink-0 tw-items-center tw-gap-1.5">{t26}{t27}{t31}{t32}{t37}</div>;
    $[81] = t26;
    $[82] = t27;
    $[83] = t31;
    $[84] = t32;
    $[85] = t37;
    $[86] = t38;
  } else {
    t38 = $[86];
  }
  let t39;
  if ($[87] !== t22 || $[88] !== t38) {
    t39 = <div className="tw-flex tw-items-start tw-justify-between tw-gap-2 tw-px-3 tw-py-2">{t22}{t38}</div>;
    $[87] = t22;
    $[88] = t38;
    $[89] = t39;
  } else {
    t39 = $[89];
  }
  let t40;
  if ($[90] !== address.display || $[91] !== address.wallet || $[92] !== copiedItem || $[93] !== handleCopyAddress || $[94] !== handleCopyEns || $[95] !== isOpen) {
    t40 = isOpen && <div id={`consolidated-address-panel-${address.wallet}`} className="tw-border-t tw-border-solid tw-border-white/10 tw-px-3 tw-pb-3 tw-pt-2"><div className="tw-space-y-2.5"><div><div className="tw-text-[10px] tw-font-semibold tw-uppercase tw-tracking-wider tw-text-iron-500">Full Address</div><div className="tw-mt-1 tw-flex tw-items-center tw-justify-between tw-gap-1.5 tw-rounded-lg tw-border tw-border-solid tw-border-white/10 tw-bg-black/40 tw-px-2.5 tw-py-1.5"><span className="tw-break-all tw-font-mono tw-text-xs tw-font-medium tw-leading-4 tw-text-iron-100">{address.wallet}</span><button type="button" aria-label="Copy full address" onClick={handleCopyAddress} className={`tw-flex tw-h-7 tw-w-7 tw-flex-shrink-0 tw-items-center tw-justify-center tw-rounded tw-border-0 tw-bg-iron-900 tw-transition tw-duration-300 tw-ease-out focus:tw-outline-none focus:tw-ring-1 focus:tw-ring-inset focus:tw-ring-emerald-400 ${copiedItem === "full-address" ? "tw-text-primary-400" : "tw-text-iron-400 hover:tw-text-iron-200"}`}><div className="tw-flex tw-h-3.5 tw-w-3.5 tw-flex-shrink-0 tw-items-center tw-justify-center [&>svg]:tw-h-full [&>svg]:tw-w-full"><CopyIcon /></div></button></div></div>{address.display && <div><div className="tw-text-[10px] tw-font-semibold tw-uppercase tw-tracking-wider tw-text-iron-500">ENS Name</div><div className="tw-mt-1 tw-flex tw-items-center tw-justify-between tw-gap-1.5 tw-rounded-lg tw-border tw-border-solid tw-border-white/10 tw-bg-black/40 tw-px-2.5 tw-py-1.5"><span className="tw-break-all tw-font-mono tw-text-xs tw-font-medium tw-leading-4 tw-text-iron-100">{address.display}</span><button type="button" aria-label="Copy ens name" onClick={handleCopyEns} className={`tw-flex tw-h-7 tw-w-7 tw-flex-shrink-0 tw-items-center tw-justify-center tw-rounded tw-border-0 tw-bg-iron-900 tw-transition tw-duration-300 tw-ease-out focus:tw-outline-none focus:tw-ring-1 focus:tw-ring-inset focus:tw-ring-emerald-400 ${copiedItem === "ens" ? "tw-text-primary-400" : "tw-text-iron-400 hover:tw-text-iron-200"}`}><div className="tw-flex tw-h-3.5 tw-w-3.5 tw-flex-shrink-0 tw-items-center tw-justify-center [&>svg]:tw-h-full [&>svg]:tw-w-full"><CopyIcon /></div></button></div></div>}</div></div>;
    $[90] = address.display;
    $[91] = address.wallet;
    $[92] = copiedItem;
    $[93] = handleCopyAddress;
    $[94] = handleCopyEns;
    $[95] = isOpen;
    $[96] = t40;
  } else {
    t40 = $[96];
  }
  let t41;
  if ($[97] !== t39 || $[98] !== t40) {
    t41 = <div className="tw-overflow-hidden tw-rounded-xl tw-border tw-border-solid tw-border-white/10 tw-bg-iron-950/40">{t39}{t40}</div>;
    $[97] = t39;
    $[98] = t40;
    $[99] = t41;
  } else {
    t41 = $[99];
  }
  let t42;
  if ($[100] !== statusMessage) {
    t42 = statusMessage && <div className="tw-pt-2 tw-text-xs tw-font-medium tw-text-iron-200">{statusMessage}</div>;
    $[100] = statusMessage;
    $[101] = t42;
  } else {
    t42 = $[101];
  }
  let t43;
  if ($[102] !== t41 || $[103] !== t42) {
    t43 = <li>{t41}{t42}</li>;
    $[102] = t41;
    $[103] = t42;
    $[104] = t43;
  } else {
    t43 = $[104];
  }
  return t43;
}
function _temp2(current_0) {
  return current_0 === "ens" ? null : current_0;
}
function _temp(current) {
  return current === "full-address" ? null : current;
}